<div app-layout>
  <ng-container *ngIf="element$ | async as element">
    <ng-container *ngIf="element.elementData as selectedElement">
      <header class="py-5">
        <div class="flex items-center justify-between">
          <div class="flex items-center justify-start">
            <svg-icon
              class="flex h-8 w-8 text-theme-500"
              [src]="'assets/icons/' + typeIcon(selectedElement.tipo)"
            ></svg-icon>
            <h2 class="pl-2 text-2xl">{{ selectedElement.titulo }}</h2>
            <span class="ml-2 text-md text-theme-900">{{ mapTypeToLabel(selectedElement) }}</span>
          </div>
          <ng-container *ngIf="false">
            <div class="flex items-center justify-between">
              <button
                type="button"
                app-icon-button
                translate
                class="group mx-2 border border-theme-500 shadow-md hover:bg-theme-500 hover:text-theme-50"
              >
                <svg-icon
                  class="mr-2 flex h-6 w-6 justify-center text-theme-500 group-hover:text-theme-contrast"
                  src="assets/icons/icon-event.svg"
                ></svg-icon>
                trilhas.criar-evento
              </button>
              <button
                type="button"
                app-icon-button
                translate
                class="group mx-2 border border-theme-500 shadow-md hover:bg-theme-500 hover:text-theme-50"
              >
                <svg-icon
                  class="mr-2 flex h-6 w-6 justify-center text-theme-500 group-hover:text-theme-contrast"
                  src="assets/icons/icon-report.svg"
                ></svg-icon>
                trilhas.acompanhar-relatorio
              </button>
            </div>
          </ng-container>
        </div>
        <span class="text-md text-theme-500">{{ selectedElement.sessao.titulo }}</span>
      </header>
      <ng-container *ngIf="elementData | async as elementInfo">
        <main class="container">
          <div class="w-12/12 flex flex-col justify-center gap-8">
            <div [ngClass]="hasAnnex ? 'w-12/12' : 'w-full'">
              <ng-container [ngSwitch]="selectedElement.tipo">
                <ng-container *ngSwitchCase="'audio'">
                  <app-audio-card [element]="elementInfo" [fullWidth]="true"></app-audio-card>
                </ng-container>
                <ng-container *ngSwitchCase="'flip'">
                  <app-flip-card [element]="elementInfo" [fullWidth]="true"></app-flip-card>
                </ng-container>
                <ng-container *ngSwitchCase="'imagem'">
                  <app-image-card [element]="elementInfo" [fullWidth]="true"></app-image-card>
                </ng-container>
                <ng-container *ngSwitchCase="'link'">
                  <app-link-card [element]="elementInfo" [fullWidth]="true"></app-link-card>
                </ng-container>
                <ng-container *ngSwitchCase="'video'">
                  <app-video-card [element]="elementInfo" [fullWidth]="true"></app-video-card>
                </ng-container>
              </ng-container>
              <div
                class="flex flex-col items-center justify-center rounded-b-2xl bg-white p-10 shadow-xl"
                [ngClass]="{ 'rounded-t-2xl': elementInfo.tipo === 'texto' }"
              >
                <div
                  *ngIf="elementInfo.conteudo"
                  class="mb-5 w-[100%]"
                  [innerHTML]="elementInfo.conteudo | safe: 'html'"
                ></div>
                <div
                  class="flex flex-col px-1 lg:w-full lg:flex-row"
                  [ngClass]="!!element.previous ? 'lg:justify-between' : 'lg:justify-end'"
                >
                  <ng-container *ngIf="element.previous as previousElement">
                    <button
                      *ngIf="!!previousElement"
                      (click)="onChangeElement(previousElement)"
                      type="button"
                      app-icon-button
                      class="group mx-2 mb-5 flex justify-between border border-theme-500 shadow-md hover:bg-theme-500 hover:text-theme-50 lg:mb-0"
                    >
                      <svg-icon
                        class="mr-2 flex h-6 w-6 justify-center text-theme-500 group-hover:text-theme-contrast"
                        src="assets/icons/icon-arrow-left-fine.svg"
                      ></svg-icon>
                      <div translate>
                        trilhas.anterior <span>{{ previousElement.titulo }}</span>
                      </div>
                      <svg-icon
                        class="ml-2 flex h-6 w-6 justify-center text-theme-500 group-hover:text-theme-contrast"
                        [src]="'assets/icons/' + typeIcon(previousElement.tipo)"
                      ></svg-icon>
                    </button>
                  </ng-container>
                  <ng-container *ngIf="element.next as nextElement">
                    <button
                      *ngIf="!!nextElement"
                      (click)="onChangeElement(nextElement)"
                      type="button"
                      app-icon-button
                      class="group mx-2 flex justify-between border border-theme-500 shadow-md hover:bg-theme-500 hover:text-theme-50"
                    >
                      <svg-icon
                        class="mr-2 flex h-6 w-6 justify-center text-theme-500 group-hover:text-theme-contrast"
                        [src]="'assets/icons/' + typeIcon(nextElement.tipo)"
                      ></svg-icon>
                      <div translate>
                        trilhas.proximo <span>{{ nextElement.titulo }}</span>
                      </div>
                      <svg-icon
                        class="ml-2 flex h-6 w-6 justify-center text-theme-500 group-hover:text-theme-contrast"
                        src="assets/icons/icon-arrow-right-fine.svg"
                      ></svg-icon>
                    </button>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </main>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
